//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { wxLogin, getInfo } from '@/api/my'
export default {
  data () {
    return {
      top: 0,
      userInfo: {}
    }
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    },
    goInfo () {
      this.$router.push({
        path: '/user-info'
      })
    },
    getUser () {
      getInfo().then(res => {
        this.userInfo = res.data
      })
    },
    loginWX () {
      var wx = api.require('wxPlus');
      console.log(JSON.stringify(wx))
      wx.auth({
        apiKey: 'wxdd5b812ed499eba5',
        scope: 'snsapi_userinfo'
      }, function (ret, err) {
        console.log(JSON.stringify(ret))
        console.log(JSON.stringify(err))
        if (ret.status) {
          wxLogin({
            code: ret.code
          }).then(res => {
            console.log(JSON.stringify(res))
            api.toast({
              msg: '登录成功',
              duration: 2000,
              location: 'middle'
            });
            // $api.setStorage("token", res.data);
          })
        } else {
          if (err.code == 3) {
            api.hideProgress();
            api.toast({
              msg: '当前设备未安装微信客户端',
              duration: 2000,
              location: 'middle'
            });
          }
        }
      });
    },
    loginH5Wx () {
      let url = process.env.BASE_URL 
      location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe09fd40992c5fb94&redirect_uri=' + url + '/login&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
    }
  },
  created () {
    if (this.$global.isApp) {
      this.top = api.safeArea.top
    }
    this.getUser()
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/userinfo.vue